import ErrorDescription from './ErrorDescription';

export default ErrorDescription;
